var _circle, _path, _circle2, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNotesGroupUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.2,
    cy: 3,
    r: 1.75,
    stroke: "currentColor",
    strokeWidth: 1.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.8 10.2C1.1 8.1 2.5 6.9 4.2 6.9C5.4 6.9 6.4 7.35 7 8.15",
    stroke: "currentColor",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.4,
    cy: 3.15,
    r: 1.9,
    stroke: "currentColor",
    strokeWidth: 1.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4 10.2C5.7 7.7 7.4 6.4 9.4 6.4C11.4 6.4 13.1 7.7 13.4 10.2",
    stroke: "currentColor",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotesGroupUsers);
export default __webpack_public_path__ + "static/media/notes-group-users.f2eb71bdafeb535a4b69c4975f8efa8b.svg";
export { ForwardRef as ReactComponent };